import React from 'react';

export default class SidebarMultiSelectExchangeLink extends React.Component {
  constructor(props) {
    super(props);

    this.onInternalClickHandler = this.onInternalClickHandler.bind(this);
  }

  onInternalClickHandler(e) {
    this.props.onClickHandler(e, this.props.shiftID);
  }

  render() {
    return (
      <li id={this.props.shiftID} onClick={this.onInternalClickHandler}>
        ▢
        {this.props.startTime}
        {' – '}
        {this.props.endTime}
      </li>
    );
  }
}
